module.exports = __webpack_public_path__ + "img/icon_wo@2x.0ea60b57.png";